import SectionHeader from "@/components/base/SectionHeader";

const steps = [
  {
    num: "01",
    icon: "ri-search-eye-line",
    title: "Understand",
    desc: "We learn about your business, users, goals and challenges.",
  },
  {
    num: "02",
    icon: "ri-map-2-line",
    title: "Strategize",
    desc: "We identify the right technology approach and define what needs to be built.",
  },
  {
    num: "03",
    icon: "ri-tools-line",
    title: "Build",
    desc: "We design and develop the solution using modern technologies.",
  },
  {
    num: "04",
    icon: "ri-line-chart-line",
    title: "Improve",
    desc: "We launch, measure, optimize and help your solution evolve.",
  },
];

export default function Approach() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeader
          eyebrow="Our Approach"
          title="From Problem to Solution."
        />

        {/* Desktop: horizontal */}
        <div className="hidden md:grid grid-cols-4 gap-6 mt-12">
          {steps.map((s, i) => (
            <div key={s.num} className="relative">
              {i < steps.length - 1 && (
                <span className="absolute top-6 left-[calc(50%+24px)] w-[calc(100%-48px)] h-px bg-background-300" />
              )}
              <div className="relative w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950 z-10">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <span className="mt-4 block font-heading text-sm font-bold text-primary-600">
                {s.num}
              </span>
              <h3 className="mt-1 font-heading text-lg font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile: vertical timeline */}
        <div className="md:hidden mt-10 flex flex-col">
          {steps.map((s, i) => (
            <div key={s.num} className="relative flex gap-4 pb-8">
              {i < steps.length - 1 && (
                <span className="absolute left-6 top-12 bottom-0 w-px bg-background-300" />
              )}
              <div className="relative w-12 h-12 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <div>
                <span className="font-heading text-sm font-bold text-primary-600">
                  {s.num}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}